export default {
    onlineCompanies:[],
    offlineCompanies:[],
    company:"",
    company_id: "",
    companyName: "",
};